// export const BASE_URL = "http://localhost:8080";
export const BASE_URL = "https://api.npbesa.in";

export const additional_URL = "/api/user/admin/get";
export const PUBLIC_TOKEN = "";
export const CONTENT_TYPE = "application/json";
export const POST_REQUEST = "POST";
export const GET_REQUEST = "GET";
export const PATCH_REQUEST = "PATCH";
export const DELETE_REQUEST = "delete";
export const HEADERS = {
  "Content-Type": CONTENT_TYPE,
  "X-Requested-With": "XMLHttpRequest",

};
export const START_INDEX = 1;
export const END_INDEX = 10;

export const VALID_RESUBMISSION_STATUSES_AND_NEW_STATUS_MAP: Record<
  string,
  string
> = {
  "Returned By Level 2 Reviewer": "Pending Level 2 Review",
  "Returned By Level 3 Reviewer": "Pending Level 3 Review",
  "Returned By Level 1 Reviewer": "Pending Level 1 Review",
};

export const VALID_PAYMENT_RESUBMISSIONS_STATUSES_AND_NEW_STATUS_MAP: Record<
  string,
  string
> = {
  "Returned For Repayment By Level 2 Reviewer":
    "Pending Payment Level 2 Review",
  "Returned For Repayment By Level 3 Reviewer":
    "Pending Payment Level 3 Review",
};

export const validRepaymentStatuses = [
  "Returned For Repayment By Level 2 Reviewer",
  "Returned For Repayment By Level 3 Reviewer",
];
export const validPaymentStatuses = [
  ...validRepaymentStatuses,
  "Pending Payment",
];
